import {
  LogLevel,
  Configuration
} from '@azure/msal-browser'

export const msalConfig:Configuration = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_MSAL_TENANT_ID}`,
    redirectUri: '',
    postLogoutRedirectUri: new URL('/#/logout', window.location.origin).toString()
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {}
}

if (process.env.VUE_APP_MSAL_LOG_LEVEL) {
  const typedLevel = process.env.VUE_APP_MSAL_LOG_LEVEL as keyof typeof LogLevel
  const level = LogLevel[typedLevel]
  msalConfig.system = {
    ...msalConfig.system,
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console
            console.error(message)
            break
          case LogLevel.Info:
            // eslint-disable-next-line no-console
            console.info(message)
            break
          case LogLevel.Verbose:
            // eslint-disable-next-line no-console
            console.debug(message)
            break
          case LogLevel.Warning:
            // eslint-disable-next-line no-console
            console.warn(message)
            break
          default:
        }
      },
      logLevel: level
    }
  }
}

export const loginRequest = {
  scopes: [
    'openid',
    'User.Read',
    'email'
  ]
}
